<template>
  <div class="py-2 px-1">
    <v-card class="rounded-t-lg">
      <v-card-title class="title style-color-main-gray">
        <span>Список дат</span>
        <v-spacer></v-spacer>

        <v-btn @click="openCreateDialog" color="secondary" text>
          <v-icon>add</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
                @click="reloadData()"
                class="mr-2"
                medium
                v-on="on"
            >
              update
            </v-icon>
          </template>
          <span>Обновить данные</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="getItems"
          :loading="isLoading"
          :footer-props="{'items-per-page-options':[25,50,100]}"
          no-data-text="Данные отсутствуют"
          no-results-text="Ничего не было найдено"
      >
        <template v-slot:item.week_day="{ item }">
          <router-link :to="goLink(item)">{{ item.week_day }}</router-link>
        </template>
        <template v-slot:item.date_started="{ item }">
          <span>{{ displayDate(item.date_started) }}</span>
        </template>
        <template v-slot:item.date_ended="{ item }">
          <span>{{ displayDate(item.date_ended) }}</span>
        </template>
        <template v-slot:item.vaccinated="{ item }">
          <v-icon v-if="item.vaccinated">done</v-icon>
          <v-icon v-else>clear</v-icon>
        </template>
        <template v-slot:item.start_intervals="{ item }">
          <span>{{ item.start_intervals }}</span>
        </template>
        <template v-slot:no-data>
          <v-card-text>Данные не загружены</v-card-text>
        </template>
        <template v-slot:item.btn="{ item }">

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  class="mr-2"
                  medium
                  @click="goInterval(item)"
              >
                date_range
              </v-icon>
            </template>
            <span>Настроить интервалы</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  class="mr-2"
                  medium
                  @click="openEditDialog(item)"
              >
                edit
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip v-if="!item.week_day" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  medium
                  @click="openDeleteDialog(item)"
              >
                delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :docs_data="docs_data"
        :event="event"
        @close="closeEditDialog"
    ></EditDialog>
    <ApplyDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить ?`"
        @close="closeDeleteDialog"
    ></ApplyDialog>
  </div>

</template>


<script>

import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";

import names from "@/modules/recording/routers/names";
import {displayDate} from "@/helper";
import EditDialog from "@/modules/recording/page/admin/events/dates/EditDialog.vue";
import ApplyDialog from "@/modules/templates/ApplyDialog.vue";
import {mapActions, mapGetters} from "vuex";


export default {
  name: "List",
  mixins: [
    PaginatedDataMapperMixin,
  ],
  props: {
    event: Number
  },
  components: {
    ApplyDialog,
    EditDialog,
  },
  computed: {
    ...mapGetters({
      getItems: 'date/getDate',
      getCount: 'date/getDateCount',
      isLoading: 'date/isLoadingDate'
    }),
  },
  data() {
    return {
      pagination: {},
      dialog_add_edit: false,
      dialog_delete: false,
      edit_status: undefined,
      docs_data: undefined,
      expanded: [],
      selectors: {
        parentCategory: [],
      },
      loading: true,
      headers: [
        {text: 'День недели', sortable: false, align: 'left', value: "week_day",},
        {text: 'Дата начала', sortable: false, align: 'left', value: "date_started",},
        {text: 'Дата окончания', sortable: false, align: 'left', value: "date_ended",},
        {text: 'Время начала интервала', sortable: false, align: 'left', value: "start_intervals",},
        {text: 'Время окончания интервала', sortable: false, align: 'left', value: "end_intervals",},
        {text: 'Запись вакцинированного', sortable: false, align: 'left', value: "vaccinated",},
        {text: 'Действия', sortable: false, align: 'right', value: "btn",},
      ]
    }
  },
  watch:{
    event(){
      this.loadData()
    }
  },
  methods: {
    displayDate,
    ...mapActions({
      loadList: 'date/loadDateList',
      deleteRole: 'date/deleteDate',
    }),
    goInterval(date) {
      this.$router.push({
        name: names.ADMIN.INTERVAL,
        params: {date: date.id, event: date.event},

      })
    },
    goLink(date) {
      return {
        name: names.ADMIN.INTERVAL,
        params: {date: date.id, event: date.event},

      }
    },
    openCreateDialog() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.docs_data = undefined
    },
    openEditDialog(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.docs_data = item
    },
    openDeleteDialog(item) {
      this.dialog_delete = true
      this.docs_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.dialog_delete = false
      this.docs_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteRole({
          id: this.docs_data.id,
          event: this.event,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      }
      this.dialog_delete = false
      this.docs_data = undefined
    },
    loadData(url = undefined) {
      this.loadList({
        url: url,
        event: this.event,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
        }
      })
    },
    reloadData() {
      this.loadData()
    },

  },
  created() {
    this.loadData()
  }
}
</script>
<style scoped>
</style>
